import { useSelector } from "react-redux";

import { FBGroup } from "api/social-account-connect/facebook";
import { Modal } from "@/components/modal/modal";
import { Button, FormSize } from "ui/ecosystems/forms";

import { FacebookGroupList } from "../facebook-group-list";
import { FacebookGroupConnectInstructions } from "../facebook-group-connect-instructions";
import { NeedHelpButton } from "../need-help-button";
import { getGroupsFx, addFacebookGroupAccountFx } from "./model";
import { getConnectButtonStateFactory } from "../connect-button";
import { PlatformTypes } from "features/post";
import { selectSocialConnectFacebookGroupState } from "../../redux-model";

interface FacebookGroupConnectDialogProps {
  show: boolean;
  onHide(): void;
  onBack(): void;
  isAlreadyAdded(acc: FBGroup): boolean;
}

export function FacebookGroupConnectDialog({
  show,
  onHide,
  onBack,
  isAlreadyAdded,
}: FacebookGroupConnectDialogProps) {
  const { data, gettingData, connectingFacebookGroupId } = useSelector(
    selectSocialConnectFacebookGroupState
  );

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title>Facebook Group connection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data ? (
          <FacebookGroupList
            groups={data.groups}
            onConnect={(group) => {
              if (data) {
                addFacebookGroupAccountFx({
                  account: data.account,
                  session: data.session,
                  group,
                });
              }
            }}
            getConnectButtonState={getConnectButtonStateFactory({
              isConnected: isAlreadyAdded,
              isConnecting: (group) => group.id === connectingFacebookGroupId,
              isDisabled: () => Boolean(connectingFacebookGroupId),
            })}
          />
        ) : (
          <FacebookGroupConnectInstructions
            ButtonProps={{
              disabled: gettingData,
              onClick: getGroupsFx,
            }}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button text size={FormSize.large} onClick={onBack}>
          Back
        </Button>
        <NeedHelpButton
          platform={PlatformTypes.facebook}
          chatQuery="accounts"
        />
      </Modal.Footer>
    </Modal>
  );
}
